let marker;
let scrollingUp;
let scrollingDown;
let activeInstance;
let lastScrollTop = 0;

const elements = {
	header: document.querySelector('.js-header'),
	main: document.querySelector('.js-header-main'),
	toolbar: document.querySelector('.js-header-toolbar'),
};

const breakpoints = {
	tablet: getComputedStyle(elements.header).getPropertyValue('--tablet'),
	desktop: getComputedStyle(elements.header).getPropertyValue('--desktop'),
};

const paddingElement = document.querySelector('.js-header-padding');

export function init() {
	if (!breakpoints.tablet || !breakpoints.desktop) {
		return;
	}

	update();
	window.addEventListener('resize', update);
	document.addEventListener('scroll', update);
}

function update() {
	let st = window.pageYOffset || document.documentElement.scrollTop;
	let alertBannerHeight = 0;
	let alertBanner = document.querySelector('.js-alert');
	if (alertBanner) {
		let alertBannerRect = alertBanner.getBoundingClientRect();
		alertBannerHeight = alertBannerRect.height;
	}
	let headerRect = elements.header.getBoundingClientRect();
	let headerRectHeight = headerRect.height;
	let headerRectOffset = alertBannerHeight + headerRectHeight;

	scrollingUp = st < lastScrollTop;
	scrollingDown = st > lastScrollTop;

	if (window.matchMedia(breakpoints.desktop).matches) {
		setActiveInstance(elements.header);
	} else if (window.matchMedia(breakpoints.tablet).matches) {
		setActiveInstance(elements.main);
	} else {
		setActiveInstance(elements.toolbar);
	}

	if (window.matchMedia(breakpoints.desktop).matches) {
		if (st === 0) {
			activeInstance.unFix();
			activeInstance.unHide();
			activeInstance.element.classList.remove('is-condensed');
		} else if (scrollingDown && st >= headerRectHeight) {
			activeInstance.fix();
			activeInstance.hide();
			activeInstance.element.classList.add('is-condensed');
		} else if (scrollingUp && st <= alertBannerHeight) {
			activeInstance.unFix();
			activeInstance.unHide();
			activeInstance.element.classList.remove('is-condensed');
		} else if (scrollingUp && st <= 170) {
			activeInstance.unHide();
			activeInstance.element.classList.remove('is-condensed');
			activeInstance.element.classList.remove('is-animatable');
		} else if (scrollingUp) {
			activeInstance.unHide();
			activeInstance.element.classList.add('is-animatable');
		}

		lastScrollTop = st <= 0 ? 0 : st;

		return;
	}

	if (window.matchMedia(breakpoints.tablet).matches) {
		let elementRect = activeInstance.element.getBoundingClientRect();
		if (!marker) {
			marker = Math.max(0, alertBannerHeight - elementRect.height + document.body.scrollTop);
		}
		if (scrollingDown && st >= headerRectOffset) {
			activeInstance.fix();
			activeInstance.hide();
		} else if (scrollingDown && st < marker) {
			activeInstance.unFix();
			activeInstance.unHide();
			activeInstance.element.classList.remove('is-animatable');
		} else if (scrollingUp && st <= headerRectOffset) {
			activeInstance.unFix();
			activeInstance.unHide();
			activeInstance.element.classList.remove('is-animatable');
		} else if (scrollingUp) {
			activeInstance.unHide();
			activeInstance.element.classList.add('is-animatable');
		}

		lastScrollTop = st <= 0 ? 0 : st;

		return;
	}

	let elementRect = document.querySelector('.js-header-main').getBoundingClientRect();

	if (!marker) {
		marker = Math.max(0, elementRect.height + alertBannerHeight + document.body.scrollTop);
	}

	if (scrollingDown && st >= headerRectOffset) {
		activeInstance.fix();
		activeInstance.hide();
	} else if (scrollingUp && st <= marker) {
		activeInstance.unFix();
		activeInstance.unHide();
		activeInstance.element.classList.remove('is-animatable');
	} else if (scrollingUp) {
		activeInstance.unHide();
		activeInstance.element.classList.add('is-animatable');
	}

	lastScrollTop = st <= 0 ? 0 : st;
}

function setActiveInstance(element) {
	if (activeInstance !== undefined && activeInstance.element === element) {
		return;
	}

	if (activeInstance) {
		activeInstance.reset();
	}

	activeInstance = sticky(element);
}

function sticky(element) {
	let fixed = false;

	function reset() {
		unFix();
		unHide();
		lastScrollTop = 0;
		element.classList.remove('is-animatable');
	}

	function hide() {
		element.classList.add('is-hidden');
	}

	function unHide() {
		element.classList.remove('is-hidden');
	}

	function fix() {
		if (fixed) {
			return fixed;
		}

		fixed = true;

		const height = element.clientHeight;
		paddingElement.style.height = `${height}px`;
		element.classList.add('is-fixed');
	}

	function unFix() {
		if (!fixed) {
			return;
		}

		fixed = false;
		element.classList.remove('is-fixed');
		paddingElement.style.height = '';
	}

	return { reset, fix, unFix, hide, unHide, element };
}
